import styled from 'styled-components'

export default styled.div`
  bottom: 0;
  display: inline-block;
  position: absolute;
  right: 20px;
`
